import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { getError } from '../../../../../components/form';
import {
  CelebrationMessageInput,
  Props as CelebrationMessageInputProps,
} from './CelebrationMessageInput';

type Props = Omit<
  CelebrationMessageInputProps,
  'value' | 'onChange' | 'error'
> & {
  name: string;
};

export const CelebrationMessageInputControlled: React.FC<
  React.PropsWithChildren<Props>
> = ({ name }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = getError(name, errors);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <CelebrationMessageInput
          error={error}
          value={field.value}
          onChange={field.onChange}
        />
      )}
    />
  );
};
